import { FileCircleIcon, RemoveIcon } from '../../assets/icons';
import { Dispatch, SetStateAction } from 'react';
import { useDropzone } from 'react-dropzone';
import Button from '../../components/Button';
import styles from './styles.module.scss';

interface Props {
    label?: string;
    file: File | null;
    uploading: boolean;
    actionBtnFunc?: any;
    isRequired?: boolean;
    description?: string;
    actionBtnTitle?: string;
    fileTypes: { [key: string]: string[] };
    setFile: Dispatch<SetStateAction<File | null>>;
};

export default function DropBox(props: Props) {
    const {
        file,
        label,
        setFile,
        uploading,
        fileTypes,
        isRequired,
        description,
        actionBtnFunc,
        actionBtnTitle,
    } = props;

    const { getRootProps, getInputProps, open } = useDropzone({
        noClick: true,
        accept: fileTypes,
        onDrop: acceptedFiles => {
            onSelectFile(acceptedFiles)
        },
    });

    function onSelectFile(files: File[]) {
        if (files && files.length > 0) {
            setFile(files[0]);
        }
    };

    return (
        <div className={styles.container}>
            {label && <span className={styles.label}>{label} {isRequired && <b>*</b>}</span>}
            <section className={styles.uploadBox}>
                <div
                    {...getRootProps({
                        className: 'dropzone',
                        style: {
                            width: '100%',
                            height: '100%',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            justifyItems: 'center',
                            position: 'relative',
                        }
                    })}
                >
                    {file && <RemoveIcon
                        fill='#FF0000'
                        onClick={() => setFile(null)}
                        style={{
                            position: 'absolute',
                            cursor: 'pointer',
                            right: '0',
                            top: '0',
                        }}
                    />}
                    <input {...getInputProps()} />
                    <FileCircleIcon />
                    {!file && <>
                        <span className={styles.title}>
                            Drop your files here or <b onClick={open}>browse</b>
                        </span>
                        <span className={styles.uploadBox_description}>
                            {description}
                        </span>
                    </>}
                    {file && <>
                        <span>{file.name}</span>
                        {actionBtnFunc && <Button
                            loading={uploading}
                            onClick={actionBtnFunc}
                            className={styles.upload_btn}
                            text={actionBtnTitle || 'Upload'}
                        />}
                    </>}
                </div>
            </section>
        </div>
    )
}
